import { httpRequest } from "../../../utils/HttpRequest";
import { IStockEntryField, IStockEntrySearch, IStockEntryDetail } from "./stockEntryType"

class StockEntryService {
    async page(searchVo: IStockEntrySearch) {
        const apiUrl = "/zzw-vrm/stockIo/in/findPage";
        return await httpRequest.post<IStockEntryDetail[]>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/stockIo/findById/${id}`;
        return await httpRequest.get<IStockEntryField>(apiUrl);
    }
    //导出
    async export(params: IStockEntrySearch) {
        const apiUrl = "/zzw-vrm/stockIo/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
}

export const stockEntryService = new StockEntryService();